export default __webpack_public_path__ + "static/media/greeting4.daaad5a0.svg";